import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { GenerationTab, useImageGeneration } from '.';

export default function GenerationTabs() {
  const { generationTab, setGenerationTab } = useImageGeneration();

  return (
    <div className='px-4'>
      <Tabs
        value={generationTab}
        onValueChange={(value) => setGenerationTab(value as GenerationTab)}
        defaultValue={GenerationTab.USE_CASE}
        className='w-full'
      >
        <TabsList className='w-full bg-zinc-900 border border-white/10 rounded-sm mb-2'>
          <TabsTrigger
            value={GenerationTab.USE_CASE}
            className='flex-1 text-gray-400 rounded-none hover:bg-zinc-800 data-[state=active]:text-stone-50 data-[state=active]:rounded-xs data-[state=active]:bg-zinc-700 cursor-pointer'
          >
            Use Case
          </TabsTrigger>
          <TabsTrigger
            value={GenerationTab.FREE_FORM}
            className='flex-1 text-gray-400 rounded-none hover:bg-zinc-800 data-[state=active]:text-stone-50 data-[state=active]:rounded-xs data-[state=active]:bg-zinc-700 cursor-pointer'
          >
            Free Form
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
